var React = require('react');

function BackArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"fill-colored-el","fill":"#333","fillRule":"evenodd","d":"M1.217 5.5l4.635 4.639a.505.505 0 01-.712.713L.147 5.857a.505.505 0 010-.714L5.139.148a.504.504 0 11.713.713L1.217 5.5z"}));
}

BackArrow.defaultProps = {"width":"6","height":"11"};

module.exports = BackArrow;

BackArrow.default = BackArrow;
